export class permissionsData{
    id: number;
    id_perfil: number;
    id_modulo: number;
    id_vista: number;
    id_elemento: number;
    tipo: string;
    permiso: string;
    modulo: string;
    vista: string;
    elemento: string;
    
    constructor(permissions: any) {
        this.id = permissions.id;
        this.id_perfil = permissions.id_perfil;    
        this.id_modulo = permissions.id_modulo; 
        this.id_vista = permissions.id_vista;
        this.id_elemento = permissions.id_elemento;
        this.tipo = permissions.tipo;
        this.permiso = permissions.permiso;
        this.modulo = permissions.modulo;
        this.vista = permissions.vista;
        this.elemento = permissions.elemento;
    }
}